jQuery(document).ready(function($) {
  //Mise à jour du taux de la HP
  var data = {
    'action': 'lpi_ajax_bestRates',
  };

  $.post('https://www.le-pret-immobilier.com/wp/wp-admin/admin-ajax.php', data, function(response) {
    var datas = JSON.parse(response);
    // fillNbr($('.sfi-hp-taux--chiffre strong'),datas['excellent']);
    $('.sfi-hp-taux--chiffre strong').html(datas['excellent']+'%');
    $('.sfi-hp-taux--chiffre strong').css('visibility','visible');
    $('.sfi-hp-taux--chiffre strong').css('opacity','1');

  }).fail(function(xhr, status, error) {
    console.log('Là, on a un problème !');
  });




  //Ajout d'une div autour des table pour les rendre responsive
  $('.wp-block-table').wrap('<div class="sfi-table"></div>');

  //OnChange sur le select des actualités pour le tri des catégories
  $('.sfi-archive--select > select').on('change',function(){
    if (this.value){
      if(this.value == 'all') {
        window.location.href='/actualites/' ;
      } else {
        window.location.href='/actualites/'+this.value ;
      }
    }
  });

  //Ajout de slick sur la HP pour les banques
  if($('.sfi-footer--partenaires_banques').length > 0){
    $('.sfi-footer--partenaires_banques').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      mobileFirst: true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.75 8.75"><defs><style>.cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.75px;}</style></defs><title>arrow</title><g id="Calque_2" data-name="Calque 2"><g id="Mode_Isolation" data-name="Mode Isolation"><polyline class="cls-1" points="0.38 0.38 4.38 4.38 0.38 8.38"/></g></g></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.75 8.75"><defs><style>.cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.75px;}</style></defs><title>arrow</title><g id="Calque_2" data-name="Calque 2"><g id="Mode_Isolation" data-name="Mode Isolation"><polyline class="cls-1" points="0.38 0.38 4.38 4.38 0.38 8.38"/></g></g></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

  //Ajout de slick sur les dernirèes actualités
  if($('.sfi-news').length > 0 && !($('body').hasClass('archive')) && !($('body').hasClass('blog')) && !($('body').hasClass('search')) ) {
    console.log('test');
    console.log($(window).width());
    $('.sfi-news').slick({
      dots: true,
      dotsClass: 'slick-dots sfi-slick-dots',
      infinite: true,
      mobileFirst: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 992,
          settings: "unslick"
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

  //Ajout de slick sur le bloc des avantages (N1)
  if($('.sfi-gut--avantages').length > 0){
    console.log($(window).width());
    $('.sfi-gut--avantages').slick({
      dots: true,
      dotsClass: 'slick-dots sfi-slick-dots',
      infinite: true,
      mobileFirst: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 992,
          settings: "unslick"
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

  //Ajout de slick sur le bloc des avantages dans le bandeau gris (N1)
  if($('.sfi-gut--avband-list').length > 0){
    console.log($(window).width());
    $('.sfi-gut--avband-list').slick({
      autoplay: true,
      infinite: true,
      mobileFirst: true,
      arrows: false,
      variableWidth: true,
      centerMode: true,
      responsive: [
        {
          breakpoint: 992,
          settings: "unslick"
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }

  //Fonction des data-url pour éviter les href
  $('[data-url]').click(function(e) {
    e.preventDefault();
    var post_url = $(this).data('url');
    var target = $(this).attr('target');

    if(post_url) {
      if(target=="_blank") {
        window.open($(this).data('url'));
      } else {
      window.location.href = post_url;
      }

    }
  });


  //Ajout des classes pour animer les liens N1 du bandeau de la HP
  if($('.sfi-bandeau--links').length > 0 && $(window).width() >= 992) {
    var liensBandeau = $('.sfi-bandeau--links_page');
    // console.log(liensBandeau);
    var tempAnim = 0;
    $.each(liensBandeau, function(){
      var test = this;
      setTimeout(function(){
        $(test).addClass('fadeInDown animated');
        $(test).css('visibility','visible');
      }, tempAnim);
      tempAnim = tempAnim + 300;
    });
  }
});

//Function pour faire des bandeaux de full largeur dans le container
function fullWidth(){
  $('.sfi-ribbon').each( function(index, val) {
        var widthObject = $(this).width() + parseInt($(this).css('padding-left')) + parseInt($(this).css('padding-right'));
        var drift = ( $(window).width() - widthObject ) / 2;

          $(this).css({
              'margin-left' :   '-' + drift + 'px',
              'margin-right':   '-' + drift + 'px',
              'padding-left':   drift + 'px',
              'padding-right':  drift + 'px'
          });
  });
}
